(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/objectSpread", "@babel/runtime/helpers/objectWithoutProperties", "react", "../common/dialog/DialogFormFactory"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/objectSpread"), require("@babel/runtime/helpers/objectWithoutProperties"), require("react"), require("../common/dialog/DialogFormFactory"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.objectSpread, global.objectWithoutProperties, global.react, global.DialogFormFactory);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _objectSpread2, _objectWithoutProperties2, _react, _DialogFormFactory) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _objectSpread2 = _interopRequireDefault(_objectSpread2);
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _react = _interopRequireDefault(_react);
  _DialogFormFactory = _interopRequireDefault(_DialogFormFactory);

  var DialogFormWrapper = function DialogFormWrapper(AntdSource) {
    var Modal = AntdSource.Modal,
        Button = AntdSource.Button;
    Modal.show = Modal.confirm;
    var compatiMap = {
      show: function show(options) {
        var className = options.className,
            others = (0, _objectWithoutProperties2.default)(options, ["className"]);
        return (0, _objectSpread2.default)({
          closablePolifill: function closablePolifill(getInstance) {
            return _react.default.createElement("div", {
              className: "dialog-polifill-cancel",
              onClick: function onClick() {
                var instance = getInstance();
                instance.hide();
              }
            }, _react.default.createElement("svg", {
              viewBox: "64 64 896 896",
              "data-icon": "close",
              width: "1em",
              height: "1em",
              fill: "currentColor",
              "aria-hidden": "true"
            }, _react.default.createElement("path", {
              d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
            })));
          }
        }, others, {
          className: "".concat(className || '', " dialog-form-wrapper"),
          iconType: true
        });
      },
      dialogInstance: function dialogInstance(_dialogInstance) {
        _dialogInstance.hide = _dialogInstance.destroy;
        return _dialogInstance;
      },
      btnLoadingProps: 'loading'
    };
    return new _DialogFormFactory.default({
      Dialog: Modal,
      Button: Button,
      compatiMap: compatiMap
    });
  };

  var _default = DialogFormWrapper;
  _exports.default = _default;
});